import mediaManage from './media-manager'
import { MediaType } from '../../common/enums'
import { setResize } from '../../common/common'
import logger from '../../common/logger'
class Element {
  constructor (options) {
    let { el, userId, mediaId, mediaType } = options
    this._el = el
    this._userId = userId
    this._mediaId = mediaId
    this.timer = null
    this.iframeEl = null
    if (mediaType === MediaType.VIDEO) {
      this.report()
    }
  }
  report () {
    let parentEl = this._el.parentNode
    this.setResize(parentEl, (param) => {
      mediaManage.reportDisplaySize(this._userId, this._mediaId, param.width, param.height)
    }, (resizeHandler) => {
      clearTimeout(this.timer);
      this.timer = setTimeout(resizeHandler, 200);
    })
  }
  renderMedia (stream) {
    this._el.srcObject = stream
  }
  unRenderMedia () {
    if (this.iframeEl) this.iframeEl.remove()
    if (!this._el || !('srcObject' in this._el)){
      logger.error("Invalid videoEle!");
      return;
    }
    this._el.srcObject = null
  }
  /**
   * 给普通元素添加onresize的方法的函数
   * @param {*} target 对应元素的父节点
   * @param {*} callback onresize 回调函数触发
   * @param {*} adapterFn 回调函数触发处理函数 （防抖等）
   */
  @setResize
  setResize (target, callback, adapterFn) {
  }
}

export default Element
